import { mapGetters } from 'vuex';
import tool from '@/common/js/tool';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getMarketPair'])
  },
  methods: {
    getPrecisionByPair(symbol, flag /* 1 = priceDec, 2 = volDec */) {
      if (!flag) {
        return '';
      }
      const marketPair = this.getMarketPair[symbol];
      if (marketPair) {
        if (flag === 1) {
          return marketPair.priceDec;
        } else if (flag === 2) {
          return marketPair.volDec;
        } else if (flag === 3) {
          return marketPair.priceDec + marketPair.volDec;
        }
      }
      return '';
    },
    processPairDisplayLabel(symbol) {
      if (!symbol) {
        return '';
      }
      const marketPair = this.getMarketPair[symbol];
      if (marketPair) {
        return marketPair.coin + '/' + marketPair.marketCoin;
      }
      return '';
    },
    convertDecimal(value, decimal) {
      if (!value) {
        return value;
      }
      return tool.decimalRetain(value, decimal);
    }
  }
};
